export default "__VITE_ASSET__e4168f45__"